export const getSetting = settingKey => state =>
  state.mySettingsReducer.settings[settingKey] || null
